import React from "react";
import DataTable from "react-data-table-component";
import moment from "moment";

export const InvitesDataTable = ({ invitesData }) => {
  return (
    <DataTable
      columns={[
        {
          name: "Name",
          selector: (guest) =>
            (guest.firstName ? guest.firstName : "") +
              (guest.lastName ? " " + guest.lastName : "") || "-",
          center: true,
        },
        {
          name: "Type",
          selector: (guest) => guest.ticketType || "-",
          center: true,
        },
        {
          name: "Date",
          selector: (guest) =>
            guest.date ? moment(guest.date).format("MMM D, YYYY") : "-",
          center: true,
        },
        {
          name: "Time",
          selector: (guest) =>
            guest.time ? moment(guest.time, "HH:mm").format("hh:mm A") : "-",
          center: true,
          width: "70px",
          style: {
            textAlign: "center",
            padding: "0 2px", // reduces padding to make column compact
          },
        },

        {
          name: "Quantity",
          selector: (guest) => guest.quantity || "-",
          center: true,
          width: "70px",
          style: {
            textAlign: "center",
            padding: "0 2px", // reduces padding to make column compact
          },
        },
        {
          name: "Email",
          selector: (guest) => guest.email || "-",
          center: true,
        },
        {
          name: "Contact",
          selector: (guest) => guest.contact || "-",
          center: true,
        },
        {
          name: "Status",
          cell: (guest) =>
            guest.invite_status === "confirmed" ? (
              <i
                className="fas fa-check-circle text-success"
                title="Confirmed"
                style={{ fontSize: "1.2em" }}
              />
            ) : guest.invite_status === "pending" ? (
              <i
                className="fas fa-clock text-warning"
                title="Pending"
                style={{ fontSize: "1.2em" }}
              />
            ) : (
              <span className="text-muted">-</span>
            ),
          center: true,
        },
      ]}
      data={invitesData}
      noHeader
      persistTableHead
      pagination
    />
  );
};
